import {UU_FAILURE, UU_PENDING, UU_SUCCESS} from './constants'
const initialState = {
  user: null,
  error: null,
  isLoading: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UU_PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case UU_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        user: action.payload,
      }

    case UU_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

export default reducer
